export enum CurrencyPlacementEnum {
  BEFORE = 'before',
  AFTER = 'after',
}
